import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  Testability,
} from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { Environment, ENVIRONMENT_NAME } from '@freelancer/config';
import { LinkTags } from '@freelancer/link-tags';
import { TimeUtils } from '@freelancer/time-utils';
import { filter } from 'rxjs/operators';

// /!\ DO ADD ANYTHING IN THERE WITHOUT TALKING TO FRONTEND INFRA FIRST /!\
// Application-wide code should be avoided as much as possible; does your code
// needs:
// - to be loaded on ALL logged-in pages?
// - AND to be loaded on ALL logged-out pages?
// - AND to be loaded on the Admin?
// - ...
// Probably not.
@Component({
  selector: 'app-root',
  template: `
    <fl-title></fl-title>
    <router-outlet></router-outlet>
    <fl-tracking *ngIf="isBrowser"></fl-tracking>
    <fl-location></fl-location>
    <fl-modal></fl-modal>
  `,
})
export class AppComponent implements OnInit {
  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(ENVIRONMENT_NAME) private environment: Environment,
    private timeUtils: TimeUtils,
    private testability: Testability,
    private router: Router,
    private linksTags: LinkTags,
  ) {}

  ngOnInit() {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.linksTags.setSiteWideLinks();
    if (this.isBrowser && this.environment !== 'prod') {
      this.router.events
        .pipe(filter((event: Event) => event instanceof NavigationEnd))
        .subscribe(() => {
          let timerDone = false;
          const timeoutId = this.timeUtils.setTimeout(() => {
            timerDone = true;
          }, 10_000);
          this.testability.whenStable(
            (e: any) => {
              clearTimeout(timeoutId);
            },
            0,
            (pendingTasks: any) => {
              if (timerDone) {
                console.warn(
                  'Pending tasks blocking zone stabilization:',
                  pendingTasks,
                );
                pendingTasks.forEach((task: any) => {
                  if (task.data.url) {
                    console.warn(
                      `Pending task: ${task.source}: ${task.data.url}`,
                    );
                  } else {
                    console.warn(
                      `Pending task: ${task.source}: ${task.creationLocation.stack}`,
                    );
                  }
                });
              }
            },
          );
        });
    }
  }
}
